import { TableLayerNode } from './TableLayerNode';
import { Node, NodeStatus } from './types';
import { getDisplayGeoJSONFeature } from './utils';

export class RecordNode implements Node {
  readonly parent: TableLayerNode;
  readonly children = undefined;
  readonly childrenStatus = NodeStatus.loaded;
  readonly error: string | undefined = undefined;
  private _record: GeoJSON.Feature;
  private _description?: string = undefined;

  constructor(record: GeoJSON.Feature, parent: TableLayerNode) {
    this._record = record;
    this.parent = parent;
    const display = this.parent.tableDisplay;
    this._description = display
      ? getDisplayGeoJSONFeature(this._record, display)
      : undefined;
  }

  get record(): GeoJSON.Feature {
    return JSON.parse(JSON.stringify(this._record));
  }

  get name() {
    return '' + this._record.id || 'id';
  }

  get description() {
    return this._description;
  }
}
